import React from 'react';
import {NavLink} from 'react-router-dom';
import classNames from 'classnames';
import MakeHash from 'make-hash';
import {TweenMax, Power1} from 'gsap';
import ButtonIcon from 'components/button/button-icon';
import Icon from 'components/icons/icon';
import NavLinks from 'components/nav/nav-links';
import Text from 'components/text/text';

export default class NavDrawer extends React.Component {
  constructor(props) {
    super(props);

    this.setUpHandlers();
  }

  /**
   * Binds any handlers to the correct context
   *
   * @method  setUpHandlers
   */
  setUpHandlers() {
    this.onCloseClick = this.handleCloseClick.bind(this);
    this.onLogoutClick = this.handleLogoutClick.bind(this);
    this.onNavLinkClick = this.handleNavLinkClick.bind(this);
  }

  /**
   * React Lifecycle Hook
   * Invoked before a mounted component receives new props. If you need to
   * update the state in response to prop changes, you may compare this.props
   * and nextProps and perform state transitions
   *
   * @method  componentWillReceiveProps
   */
  componentWillReceiveProps(nextProps) {
    if (nextProps.isOpen && !this.props.isOpen) {
      this.fadeIn();
    }
  }

  handleCloseClick(event) {
    this.fadeOut(() => {
      this.props.toggleNavMenu();
    });
  }

  handleLogoutClick(event) {
    this.fadeOut(() => {
      this.props.onLogout();
    });
  }

  handleNavLinkClick(event) {
    this.fadeOut(() => {
      this.props.onNavLinkClick();
    });
  }

  fadeIn() {
    TweenMax.to(this.drawer, 0.5, {
      'opacity': 1,
      'ease': Power1.easeOut,
      'onComplete': () => {
        TweenMax.to(this.content, 0.75, {
          'opacity': 1,
          'y': 0,
          'ease': Power1.easeOut
        });
      }
    });
  }

  fadeOut(callback) {
    TweenMax.to(this.content, 0.3, {
      'opacity': 0,
      'y': 20,
      'ease': Power1.easeIn,
      'onComplete': () => {
        TweenMax.to(this.drawer, 0.5, {
          'opacity': 0,
          'ease': Power1.easeIn,
          'onComplete': callback
        });
      }
    });
  }

  _renderOption(link) {
    if (link.action) {
      return (
        <button className="navDrawer-authLink" onClick={link.action}>
          <Text
            className="mix-txt_uppercase"
            color="DefaultBlue"
            type="sm"
            weight="light"
          >
            {link.description}
          </Text>
        </button>
      )
    } else {
      return (
        <NavLink className="navDrawer-authLink" to={link.path} onClick={this.onNavLinkClick}>
          <Text
            className="mix-txt_uppercase"
            color="DefaultBlue"
            type="sm"
            weight="light"
          >
            {link.description}
          </Text>
        </NavLink>
      )
    }

  }

  _renderSessionOptions() {
    return this.props.sessionLinks.map((link, i) => {
      const option = this._renderOption(link);

      return (
        <li key={MakeHash(`${link.description}-${i}`)}>
          {option}
        </li>
      )
    })
  }

  render() {
    const { isOpen, toggleNavMenu, links } = this.props;
    const sessionOptions = this._renderSessionOptions();
    const drawerClasses = classNames(
      'navDrawer',
      {
        'navDrawer_isVisible': isOpen
      }
    );

    return (
      <section className={drawerClasses} ref={el => { this.drawer = el; }}>
        <div className="navDrawer-close">
          <ButtonIcon
            description="Close Dialog"
            iconClasses="mix-icon_strokeColorDefaultBlue"
            iconType="x"
            iconSize="md"
            onClick={this.onCloseClick}
          />
        </div>
        <div className="navDrawer-inner" ref={el => { this.content = el; }}>
          <NavLinks
            isVisible={this.props.authenticated}
            onNavLinkClick={this.onNavLinkClick}
          />
          <ul className="navDrawer-authLinks">
            {sessionOptions}
          </ul>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/client/components/nav/nav-drawer.jsx